import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import type { DocumentTypeDatabase } from '../../../types';
import { useSpace } from '../../../hooks/useSpace';
import { keys } from './keys';

async function fetchDocumentTypes(spaceId: string): Promise<DocumentTypeDatabase[]> {
  const { data, error } = await apiClient
    .from('document_types')
    .select('*')
    .eq('space_id', spaceId)
    .order('name', { ascending: true });

  if (error) {
    throw error;
  }

  return data ?? [];
}

export function useGetDocumentTypes(spaceIdOverride?: string) {
  const { currentSpace } = useSpace();
  const spaceId = spaceIdOverride ?? currentSpace?.id;

  return useQuery({
    queryKey: keys.getDocumentTypes(spaceId ?? ''),
    queryFn: () => fetchDocumentTypes(spaceId!),
    enabled: !!spaceId,
  });
}
